import type { NavDropdown } from "../../interfaces/routing";
import type { Config } from "../../interfaces/config";
import type { BootUser } from "../../../reducers/boot";
import { DROPDOWN_KEYS, DROPDOWN_LABELS } from "../../enums/routing-enums";

/**
 * Builds the Academy navigation link with optional authentication token
 */
const buildAcademyLink = (baseLink: string, cognitoToken?: string): string => {
  if (!baseLink) return "";
  return cognitoToken ? `${baseLink}?q=${cognitoToken}` : baseLink;
};

/**
 * Creates the Academy menu configuration based on market config and user
 */
export const createAcademyMenu = (configuration: Config, user: BootUser): NavDropdown => {
  const showAcademy = configuration?.navigation?.showAcademy;
  const baseLink = configuration?.externalIntegration?.academy?.navigationlink;
  const navigationLink = buildAcademyLink(baseLink, user?.cognitoToken);

  const baseMenu: NavDropdown = {
    key: DROPDOWN_KEYS.ACADEMY,
    label: DROPDOWN_LABELS.ACADEMY,
    items: [],
  };

  if (showAcademy && navigationLink) {
    return { ...baseMenu, path: navigationLink, skip: false };
  }

  return { ...baseMenu, skip: true };
};
